import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material';
import { useFormikContext } from 'formik';
import {
    getAllProcedureVariables,
    copyField,
} from 'GeminiViewerComponent/components/Procedure/features/procedureSlice';
import { FIELD_TYPES } from '../../helpers/constant';

const FieldDuplicateDialog = ({
    openDuplicateConfirmDialog,
    closeDuplicateConfirmDialog,
    fields,
    procedureNodes,
    setSortedNodes,
    selectedDuplicateField,
    setTreeState,
}) => {
    const { setFieldValue } = useFormikContext();

    const activeFieldName = FIELD_TYPES.find((field) => field.id === selectedDuplicateField?.type)?.display_name;

    const addField = (tree, field) => {
        tree.items[field.id] = {
            id: field.id,
            children: [],
            hasChildren: field.type === 'group' || field.type === 'table' ? false : true,
            isExpanded: field.type === 'group' || field.type === 'table' ? true : false,
            isChildrenLoading: false,
            data: field,
        };
        if (field.type === 'group' || field.type === 'table') {
            const group = tree.items[field.id];
            group.hasChildren = false;
            field?.fields?.forEach((fld) => {
                group.children.push(fld.id);
                addField(tree, fld);
            });
        }
    };

    const fieldsToTree = (fields) => {
        var tree = {
            rootId: 'root',
            items: {
                root: {
                    id: 'root',
                    children: [],
                    hasChildren: false,
                    isExpanded: true,
                    isChildrenLoading: false,
                },
            },
        };

        fields?.forEach((field) => {
            addField(tree, field);
            tree.items.root.children.push(field.id);
        });

        return tree;
    };

    const insertDuplicateField = (original, duplicate) => {
        if (!Array.isArray(fields) || fields.length === 0) {
            return [duplicate];
        }
        let isAdded = false;
        let rootNodes = [];
        fields.forEach((nd) => {
            if (isAdded) {
                rootNodes = [...rootNodes, nd];
            } else {
                if (nd.id === original.id) {
                    rootNodes = [...rootNodes, original, duplicate];
                    isAdded = true;
                } else if (nd.type === 'group' || nd.type === 'table') {
                    let ndFields = [];
                    nd?.fields?.forEach((field) => {
                        if (isAdded) {
                            ndFields = [...ndFields, field];
                        } else {
                            if (field.id === original.id) {
                                ndFields = [...ndFields, original, duplicate];
                                isAdded = true;
                            } else {
                                ndFields = [...ndFields, field];
                            }
                        }
                    });
                    rootNodes = [...rootNodes, { ...nd, fields: ndFields }];
                } else {
                    rootNodes = [...rootNodes, nd];
                }
            }
        });
        return rootNodes;
    };

    const handleFieldDuplicate = () => {
        const variableNames = getAllProcedureVariables(procedureNodes).map((v) => v.name);
        const copy = copyField(selectedDuplicateField, variableNames);
        const finalNodes = insertDuplicateField(selectedDuplicateField, copy);
        setSortedNodes(finalNodes);
        setFieldValue('fields', finalNodes);
        setTreeState({ tree: fieldsToTree(finalNodes) });
        closeDuplicateConfirmDialog();
    };

    return (
        <Dialog
            open={openDuplicateConfirmDialog}
            onClose={closeDuplicateConfirmDialog}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
        >
            <DialogTitle id="alert-dialog-title">{`Duplicate ${activeFieldName} Field`}</DialogTitle>
            <DialogContent>
                <DialogContentText id="alert-dialog-description">
                    {`Are you sure you want to duplicate this field?`}
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button onClick={closeDuplicateConfirmDialog} autoFocus>
                    No
                </Button>
                <Button variant="contained" onClick={() => handleFieldDuplicate()}>
                    Yes
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export { FieldDuplicateDialog };
